<mat-progress-bar *ngIf="submiting" color="primary" mode="indeterminate"></mat-progress-bar>
<mat-card class="mat-elevation-z6" [ngClass]="{ loading: submiting }">

    <div mat-card-image>

        <img src="assets/images/icon.png" alt="" />

    </div>

    <mat-card-header>        
        <mat-card-title>
            Agora informe sua senha
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>

        <form [formGroup]="form">

            <div class="row">
                <mat-form-field  appearance="outline">
                    <mat-label>Sua senha</mat-label>
                    <input [type]=" showPassword ? 'password' : 'text' " matInput placeholder="Informe sua senha" formControlName="password" />
                </mat-form-field>
                <button mat-icon-button color="primary" type="button" (click)="showPassword = !showPassword">                    
                    <mat-icon *ngIf="!showPassword">visibility</mat-icon>
                    <mat-icon *ngIf="showPassword">visibility_off</mat-icon>
                </button>
            </div>

        </form>

    </mat-card-content>

    <mat-card-actions>
        <div>
            <button color="primary" mat-button (click)="recoveryPass()">Recuperar senha</button>
            <button class="custom-primary" mat-raised-button
                [disabled]="submiting" (click)="submit()">Entrar</button>
        </div>
        <button mat-icon-button color="primary" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </mat-card-actions>

</mat-card>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>